import React, { Component } from "react";
import { Select, Checkbox, Button, Icon, Tooltip, Form, InputNumber, message } from "antd";
import LangContext from "../../contextProvider/LangContext";
import GenericModal from "../../components/GenericModal";
import GenericSelector from "../../components/GenericSelector";
import { Job, OutputType, ProcessType, User } from "../../JmReact";



class FoodDishDetailsEditMulti extends Component {
    state = {
        modalEdit: false,
        selectorChecked: [],
        price: 0,
        percent: 0,
    }

    static contextType = LangContext;
    getText = (id) => this.context.get(id) || '[' + id + ']';

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    onSave = () => {
        const { price, percent, selectorChecked } = this.state
        this.sendAPI("create_edit_food_details_multi", { price, percent, idList: selectorChecked.join(",") }, () => {
            message.success(this.getText(21985))
            this.onCancel()
            this.props.refreshData()
        })
    }


    onCancel = () => {
        this.setState({
            modalEdit: false,
            selectorChecked: [],
            price: 0,
            percent: 0,
        })
    }

    onClear = () => {
        this.setState({
            selectorChecked: [],
            price: 0,
            percent: 0,
        })
    }


    render() {
        return (<>
            <Tooltip title={this.getText(21979)}>
                <Button key={"DetailsEditMultiBtn"} className={"btn"} style={{ marginTop: "5px", marginLeft: "5px" }} onClick={() => {
                    this.setState({ modalEdit: true })
                }}>
                    <Icon style={{ fontSize: 16 }} className={"clickable margin-4"} type={"dollar"} />
                </Button>
            </Tooltip>
            <GenericModal
                visible={this.state.modalEdit}
                onCancel={() => { this.setState({ modalEdit: false }) }}
                title={this.getText(21980)}
                width={500}
                footer={[
                    <Button onClick={this.onCancel}>{this.getText(21981)}</Button>,
                    <Button onClick={this.onClear}>{this.getText(21986)}</Button>,
                    <Button type="primary" disabled={!this.state.selectorChecked.length} onClick={this.onSave}>{this.getText(21982)}</Button>,
                ]}
            >
                <GenericSelector
                    {...this.props}
                    multi
                    value={this.state.selectorChecked}
                    onChange={e => { this.setState({ selectorChecked: e }) }}
                />
                <Form.Item label={this.getText(21983)}>
                    <InputNumber
                        min={0}
                        value={this.state.price}
                        onChange={e => { this.setState({ price: e, percent: 0 }) }}
                    />
                </Form.Item>
                <Form.Item label={this.getText(21984)}>
                    <InputNumber
                        min={0}
                        max={100}
                        value={this.state.percent}
                        onChange={e => { this.setState({ price: 0, percent: e }) }}
                    />
                </Form.Item>
            </GenericModal>
        </>)
    }

}
export default FoodDishDetailsEditMulti;